module.exports = __WEBPACK_EXTERNAL_MODULE_499__;


//////////////////
// WEBPACK FOOTER
// external "bi/moser/moser.min"
// module id = 499
// module chunks = 1